import { useState, useEffect } from 'react'
import moment from 'moment'

export const useAudioMetadata = (src: string | null) => {
  const [seconds, setSeconds] = useState<number | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!src) return

    let audio: HTMLAudioElement | null = new Audio()

    const handleLoadedMetadata = () => {
      if (audio?.duration && !isNaN(audio.duration)) {
        setSeconds(audio.duration)
      } else {
        setError('Invalid duration')
      }
    }

    const handleError = () => {
      setError('Failed to load metadata')
    }

    audio.preload = 'metadata'
    audio.src = src
    audio.addEventListener('loadedmetadata', handleLoadedMetadata)
    audio.addEventListener('error', handleError)

    return () => {
      audio.removeEventListener('loadedmetadata', handleLoadedMetadata)
      audio.removeEventListener('error', handleError)
      audio = null
    }
  }, [src])

  return {
    duration: seconds,
    formattedDuration: formatDuration(seconds),
    error,
  }
}

export const formatDuration = (seconds: number) => {
  const duration = moment.duration(seconds, 'seconds')

  const rawHours = duration.hours()
  const rawMinutes = duration.minutes()
  const remainingSeconds = duration.seconds()

  let hours = rawHours
  let minutes = rawMinutes

  if (remainingSeconds > 30) {
    minutes += 1
  }

  if (minutes >= 60) {
    hours += 1
    minutes = 0
  }

  if (hours > 0 && minutes > 0) return `${hours} hr, ${minutes} min`
  if (hours > 0) return `${hours} hr`
  if (minutes > 0) return `${minutes} min`
  return '<1 min'
}
